(function () {
	'use strict';

	document.addEventListener('DOMContentLoaded', function () {
		const layout = document.getElementById('catalog-layout');
		if (!layout || typeof themeAjax === 'undefined') {
			return;
		}

		const termId = parseInt(layout.dataset.termId || '0', 10);
		const desktopForm = document.getElementById('catalog-filters-form');
		const mobileForm = document.getElementById('catalog-filters-form-mobile');
		const items = document.getElementById('catalog-products-items');
		const loadMore = document.getElementById('catalog-products-load-more');
		const resetBtn = document.getElementById('catalog-filters-reset');
		const pickedBlock = document.getElementById('catalog-filter-picked');
		const pickedScroll = document.getElementById('catalog-filter-picked-scroll');
		const pickedClear = document.getElementById('catalog-filter-picked-clear');
		const pickedPrev = document.getElementById('catalog-filter-picked-prev');
		const pickedNext = document.getElementById('catalog-filter-picked-next');
		const mobileFilters = document.querySelector('[data-target="catalog-mobile-filters"]');
		const mobileFiltersOpen = document.querySelector('[data-target="catalog-mobile-filters-open"]');
		const mobileFiltersClose = document.querySelector('[data-target="catalog-mobile-filters-close"]');
		const mobileFiltersApply = document.querySelector('[data-target="catalog-mobile-filters-apply"]');
		const mobileProductCount = document.querySelector('.catalog-mobile-filters__product-count');
		const mobileMediaQuery = window.matchMedia('(max-width: 767px)');
		const sortSelect = document.getElementById('catalog-sort');
		const defaultSort = sortSelect?.querySelector('option[value="default"]') ? 'default' : (sortSelect?.options[0]?.value || 'default');

		if (!desktopForm && !mobileForm) {
			return;
		}

		const chipIcon = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M18 6L6 18" stroke="#272729" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /><path d="M6 6L18 18" stroke="#272729" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /></svg>';

		let loading = false;
		let debounceTimer = null;
		let mobileCountDebounceTimer = null;

		const getActiveForm = () => {
			if (mobileMediaQuery.matches && mobileForm) {
				return mobileForm;
			}

			return desktopForm;
		};

		const getOtherForm = (currentForm) => {
			if (!currentForm) {
				return null;
			}

			return currentForm === mobileForm ? desktopForm : mobileForm;
		};

		const getPriceBlock = (targetForm) => {
			return targetForm ? targetForm.querySelector('.catalog-filters__price') : null;
		};

		const formatPrice = (value) => {
			const number = Math.round(parseFloat(value) || 0);
			return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ₽';
		};

		const formatPriceInput = (value) => {
			const number = Math.round(parseFloat(value) || 0);
			return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
		};

		const parsePriceInput = (value) => {
			return parseFloat(String(value).replace(/\s/g, '').replace(/[^\d]/g, '')) || 0;
		};

		const getBounds = (targetForm) => {
			const priceBlock = getPriceBlock(targetForm || getActiveForm());

			if (!priceBlock) {
				return { min: 0, max: 0 };
			}

			return {
				min: parseFloat(priceBlock.dataset.min || '0'),
				max: parseFloat(priceBlock.dataset.max || '0'),
			};
		};

		const updatePriceLabels = (targetForm) => {
			const priceBlock = getPriceBlock(targetForm);

			if (!priceBlock || !targetForm) {
				return;
			}

			const minInput = targetForm.querySelector('.catalog-filters__range--min');
			const maxInput = targetForm.querySelector('.catalog-filters__range--max');
			const minThumb = priceBlock.querySelector('.catalog-filters__range-thumb--min');
			const maxThumb = priceBlock.querySelector('.catalog-filters__range-thumb--max');
			const minTextInput = priceBlock.querySelector('.catalog-filters__price-input--min');
			const maxTextInput = priceBlock.querySelector('.catalog-filters__price-input--max');
			const fillEl = priceBlock.querySelector('.catalog-filters__price-fill');

			if (!minInput || !maxInput) {
				return;
			}

			if (minTextInput) {
				minTextInput.value = formatPriceInput(minInput.value);
			}

			if (maxTextInput) {
				maxTextInput.value = formatPriceInput(maxInput.value);
			}

			if (!fillEl) {
				return;
			}

			const bounds = getBounds(targetForm);
			const range = bounds.max - bounds.min;

			if (range <= 0) {
				fillEl.style.left = '0%';
				fillEl.style.right = '0%';
				return;
			}

			const minValue = parseFloat(minInput.value);
			const maxValue = parseFloat(maxInput.value);
			const leftPercent = ((minValue - bounds.min) / range) * 100;
			const rightPercent = ((bounds.max - maxValue) / range) * 100;
			const setThumbPosition = (thumb, value) => {
				if (!thumb) {
					return;
				}

				const percent = ((value - bounds.min) / range) * 100;
				thumb.style.left = `calc(var(--thumb-size) / 2 + (100% - var(--thumb-size)) * ${percent} / 100)`;
			};

			fillEl.style.left = leftPercent + '%';
			fillEl.style.right = rightPercent + '%';
			setThumbPosition(minThumb, minValue);
			setThumbPosition(maxThumb, maxValue);
		};

		const syncForms = (sourceForm) => {
			const targetForm = getOtherForm(sourceForm);

			if (!sourceForm || !targetForm) {
				return;
			}

			sourceForm.querySelectorAll('.catalog-filters__input').forEach((input) => {
				const targetInput = targetForm.querySelector(
					`[name="${CSS.escape(input.name)}"][value="${CSS.escape(input.value)}"]`
				);

				if (targetInput) {
					targetInput.checked = input.checked;
				}
			});

			const sourceMin = sourceForm.querySelector('.catalog-filters__range--min');
			const sourceMax = sourceForm.querySelector('.catalog-filters__range--max');
			const targetMin = targetForm.querySelector('.catalog-filters__range--min');
			const targetMax = targetForm.querySelector('.catalog-filters__range--max');

			if (sourceMin && targetMin) {
				targetMin.value = sourceMin.value;
			}

			if (sourceMax && targetMax) {
				targetMax.value = sourceMax.value;
			}

			updatePriceLabels(targetForm);
			updateFilterLabelStates(targetForm);
		};

		const syncPriceRanges = (activeInput, targetForm) => {
			if (!targetForm) {
				return;
			}

			const minInput = targetForm.querySelector('.catalog-filters__range--min');
			const maxInput = targetForm.querySelector('.catalog-filters__range--max');
			const bounds = getBounds(targetForm);

			if (!minInput || !maxInput) {
				return;
			}

			let minValue = parseFloat(minInput.value);
			let maxValue = parseFloat(maxInput.value);

			if (activeInput === minInput && minValue > maxValue) {
				maxValue = minValue;
				maxInput.value = String(maxValue);
			}

			if (activeInput === maxInput && maxValue < minValue) {
				minValue = maxValue;
				minInput.value = String(minValue);
			}

			minValue = Math.max(bounds.min, Math.min(minValue, bounds.max));
			maxValue = Math.max(bounds.min, Math.min(maxValue, bounds.max));

			minInput.value = String(minValue);
			maxInput.value = String(maxValue);

			updatePriceLabels(targetForm);
			syncForms(targetForm);
		};

		const syncPriceFromText = (activeTextInput, targetForm) => {
			const priceBlock = getPriceBlock(targetForm);

			if (!targetForm || !priceBlock) {
				return;
			}

			const minInput = targetForm.querySelector('.catalog-filters__range--min');
			const maxInput = targetForm.querySelector('.catalog-filters__range--max');
			const minTextInput = priceBlock.querySelector('.catalog-filters__price-input--min');
			const maxTextInput = priceBlock.querySelector('.catalog-filters__price-input--max');
			const bounds = getBounds(targetForm);

			if (!minInput || !maxInput || !minTextInput || !maxTextInput) {
				return;
			}

			let minValue = parsePriceInput(minTextInput.value);
			let maxValue = parsePriceInput(maxTextInput.value);

			if (activeTextInput === minTextInput && minValue > maxValue) {
				maxValue = minValue;
			}

			if (activeTextInput === maxTextInput && maxValue < minValue) {
				minValue = maxValue;
			}

			minValue = Math.max(bounds.min, Math.min(minValue, bounds.max));
			maxValue = Math.max(bounds.min, Math.min(maxValue, bounds.max));

			if (minValue > maxValue) {
				minValue = maxValue;
			}

			minInput.value = String(minValue);
			maxInput.value = String(maxValue);

			updatePriceLabels(targetForm);
			syncForms(targetForm);
		};

		const updateFilterLabelStates = (targetForm) => {
			if (!targetForm) {
				return;
			}

			targetForm.querySelectorAll('.catalog-filters__label').forEach((label) => {
				const input = label.querySelector('.catalog-filters__input');
				label.classList.toggle('catalog-filters__label_active', !!(input && input.checked));
			});

			targetForm.querySelectorAll('.catalog-filters__switch').forEach((switchLabel) => {
				const input = switchLabel.querySelector('.catalog-filters__input');
				switchLabel.classList.toggle('catalog-filters__switch_active', !!(input && input.checked));
			});
		};

		const collectActiveChips = () => {
			const chips = [];
			const form = getActiveForm();

			if (!form) {
				return chips;
			}

			form.querySelectorAll('.catalog-filters__input:checked').forEach((input) => {
				const isSubcategory = input.name.includes('subcategory');

				chips.push({
					type: isSubcategory ? 'subcategory' : 'attribute',
					value: input.value,
					attr: input.dataset.filterAttr || '',
					inputId: input.id,
					label: input.dataset.chipLabel || input.value,
				});
			});

			const bounds = getBounds(form);
			const minInput = form.querySelector('.catalog-filters__range--min');
			const maxInput = form.querySelector('.catalog-filters__range--max');

			if (minInput && maxInput && bounds.max > 0) {
				const minValue = parseFloat(minInput.value);
				const maxValue = parseFloat(maxInput.value);

				if (minValue > bounds.min || maxValue < bounds.max) {
					chips.push({
						type: 'price',
						label: formatPrice(minValue) + ' — ' + formatPrice(maxValue),
					});
				}
			}

			return chips;
		};

		const buildChipHtml = (chip) => {
			const attrs = [`data-chip-type="${chip.type}"`];

			if (chip.value) {
				attrs.push(`data-chip-value="${chip.value}"`);
			}

			if (chip.attr) {
				attrs.push(`data-chip-attr="${chip.attr}"`);
			}

			if (chip.inputId) {
				attrs.push(`data-chip-input="${chip.inputId}"`);
			}

			return (
				'<button type="button" class="catalog-filter-picked__chip" ' +
				attrs.join(' ') +
				'>' +
				'<span class="catalog-filter-picked__chip-text">' +
				chip.label +
				'</span>' +
				chipIcon +
				'</button>'
			);
		};

		const updatePickedCarouselArrows = () => {
			if (!pickedScroll || !pickedPrev || !pickedNext) {
				return;
			}

			const carousel = pickedScroll.closest('.catalog-filter-picked__carousel');
			pickedScroll.style.maxWidth = '';

			const maxScroll = pickedScroll.scrollWidth - pickedScroll.clientWidth;
			const hasOverflow = maxScroll > 1;

			if (carousel) {
				carousel.classList.toggle('catalog-filter-picked__carousel--scrollable', hasOverflow);
			}

			if (!hasOverflow) {
				pickedPrev.hidden = true;
				pickedNext.hidden = true;
				return;
			}

			const atStart = pickedScroll.scrollLeft <= 1;
			const atEnd = pickedScroll.scrollLeft >= maxScroll - 1;

			pickedPrev.hidden = atStart;
			pickedNext.hidden = atEnd;
		};

		const schedulePickedCarouselUpdate = () => {
			window.requestAnimationFrame(() => {
				updatePickedCarouselArrows();
			});
		};

		const scrollPickedCarousel = (direction) => {
			if (!pickedScroll) {
				return;
			}

			const step = Math.max(160, Math.round(pickedScroll.clientWidth * 0.75));
			pickedScroll.scrollBy({ left: direction * step, behavior: 'smooth' });
		};

		const findChipInput = (chip) => {
			if (chip.dataset.chipInput) {
				return document.getElementById(chip.dataset.chipInput);
			}

			const type = chip.dataset.chipType;
			const value = chip.dataset.chipValue;

			if (!value) {
				return null;
			}

			for (const targetForm of [desktopForm, mobileForm]) {
				if (!targetForm) {
					continue;
				}

				for (const input of targetForm.querySelectorAll('.catalog-filters__input')) {
					if (input.value !== value) {
						continue;
					}

					if (type === 'subcategory' && input.name === 'filter[subcategory][]') {
						return input;
					}

					if (type === 'attribute' && chip.dataset.chipAttr && input.dataset.filterAttr === chip.dataset.chipAttr) {
						return input;
					}
				}
			}

			return null;
		};

		const bindPickedChipHandlers = () => {
			if (!pickedScroll) {
				return;
			}

			pickedScroll.querySelectorAll('.catalog-filter-picked__chip').forEach((chip) => {
				chip.addEventListener('click', () => {
					const type = chip.dataset.chipType;

					if (type === 'price') {
						[desktopForm, mobileForm].filter(Boolean).forEach((targetForm) => {
							const bounds = getBounds(targetForm);
							const minInput = targetForm.querySelector('.catalog-filters__range--min');
							const maxInput = targetForm.querySelector('.catalog-filters__range--max');

							if (minInput) {
								minInput.value = String(bounds.min);
							}

							if (maxInput) {
								maxInput.value = String(bounds.max);
							}

							updatePriceLabels(targetForm);
						});
					} else {
						const input = findChipInput(chip);

						if (input) {
							input.checked = false;
							syncForms(input.form);
						}
					}

					requestProducts(1, false);
				});
			});
		};

		const updateActiveFilterChips = () => {
			if (!pickedBlock || !pickedScroll) {
				return;
			}

			const chips = collectActiveChips();

			pickedScroll.innerHTML = chips.map(buildChipHtml).join('');
			pickedBlock.hidden = chips.length === 0;

			bindPickedChipHandlers();
			schedulePickedCarouselUpdate();
		};

		const getSortValue = () => {
			return sortSelect?.value || defaultSort;
		};

		const appendSortToFormData = (formData) => {
			formData.set('sort', getSortValue());
		};

		const appendPriceFiltersToFormData = (formData, form) => {
			if (!form) {
				return;
			}

			const bounds = getBounds(form);
			const minInput = form.querySelector('.catalog-filters__range--min');
			const maxInput = form.querySelector('.catalog-filters__range--max');

			formData.delete('price_min');
			formData.delete('price_max');

			if (minInput && bounds.max > 0 && parseFloat(minInput.value) > bounds.min) {
				formData.set('price_min', minInput.value);
			}

			if (maxInput && bounds.max > 0 && parseFloat(maxInput.value) < bounds.max) {
				formData.set('price_max', maxInput.value);
			}
		};

		const buildSearchParams = () => {
			const params = new URLSearchParams();
			const form = getActiveForm();

			if (!form) {
				return params;
			}

			const bounds = getBounds(form);
			const minInput = form.querySelector('.catalog-filters__range--min');
			const maxInput = form.querySelector('.catalog-filters__range--max');

			if (minInput && bounds.max > 0 && parseFloat(minInput.value) > bounds.min) {
				params.set('price_min', minInput.value);
			}

			if (maxInput && bounds.max > 0 && parseFloat(maxInput.value) < bounds.max) {
				params.set('price_max', maxInput.value);
			}

			form.querySelectorAll('.catalog-filters__input:checked').forEach((input) => {
				params.append(input.name, input.value);
			});

			const sort = getSortValue();
			if (sort && sort !== defaultSort) {
				params.set('sort', sort);
			}

			return params;
		};

		const hasActiveFilters = () => collectActiveChips().length > 0;

		const updateResetButton = () => {
			if (resetBtn) {
				resetBtn.hidden = !hasActiveFilters();
			}
		};

		const updateMobileProductCountDisplay = (count) => {
			if (!mobileProductCount) {
				return;
			}

			mobileProductCount.textContent = String(count);
		};

		const requestMobileProductCount = () => {
			if (!mobileForm) {
				return;
			}

			const formData = new FormData(mobileForm);
			appendPriceFiltersToFormData(formData, mobileForm);
			appendSortToFormData(formData);
			formData.append('action', 'filter_products');
			formData.append('nonce', themeAjax.productNonce);
			formData.append('term_id', String(termId));
			formData.append('page', '1');
			formData.append('count_only', '1');

			fetch(themeAjax.ajaxUrl, {
				method: 'POST',
				body: formData,
				credentials: 'same-origin',
			})
				.then((response) => response.json())
				.then((response) => {
					if (response.success && typeof response.data.found === 'number') {
						updateMobileProductCountDisplay(response.data.found);
					}
				})
				.catch(() => {});
		};

		const scheduleMobileProductCount = () => {
			clearTimeout(mobileCountDebounceTimer);
			mobileCountDebounceTimer = setTimeout(requestMobileProductCount, 300);
		};

		const scheduleFilterUpdate = (targetForm) => {
			if (targetForm === mobileForm) {
				scheduleMobileProductCount();
				return;
			}

			scheduleFilter();
		};

		const openMobileFilters = () => {
			if (!mobileFilters) {
				return;
			}

			mobileFilters.classList.add('catalog-mobile-filters_active');
			mobileFilters.setAttribute('aria-hidden', 'false');
			document.body.classList.add('catalog-mobile-filters-open');
			requestMobileProductCount();
		};

		const closeMobileFilters = () => {
			if (!mobileFilters) {
				return;
			}

			mobileFilters.classList.remove('catalog-mobile-filters_active');
			mobileFilters.setAttribute('aria-hidden', 'true');
			document.body.classList.remove('catalog-mobile-filters-open');
		};

		if (mobileFiltersOpen) {
			mobileFiltersOpen.addEventListener('click', openMobileFilters);
		}

		if (mobileFiltersClose) {
			mobileFiltersClose.addEventListener('click', closeMobileFilters);
		}

		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape' && mobileFilters?.classList.contains('catalog-mobile-filters_active')) {
				closeMobileFilters();
			}
		});

		const resetForm = (targetForm) => {
			if (!targetForm) {
				return;
			}

			const bounds = getBounds(targetForm);
			const minInput = targetForm.querySelector('.catalog-filters__range--min');
			const maxInput = targetForm.querySelector('.catalog-filters__range--max');

			if (minInput) {
				minInput.value = String(bounds.min);
			}

			if (maxInput) {
				maxInput.value = String(bounds.max);
			}

			targetForm.querySelectorAll('.catalog-filters__input:checked').forEach((input) => {
				input.checked = false;
			});

			updatePriceLabels(targetForm);
			updateFilterLabelStates(targetForm);
		};

		const resetAllFilters = () => {
			[desktopForm, mobileForm].filter(Boolean).forEach(resetForm);
			requestProducts(1, false);
		};

		const setLoading = (isLoading) => {
			loading = isLoading;
			layout.classList.toggle('is-loading', isLoading);

			if (loadMore) {
				loadMore.disabled = isLoading;
				const text = loadMore.querySelector('span');
				if (text) {
					text.textContent = isLoading ? 'Загрузка...' : 'Показать ещё';
				}
			}
		};

		const updatePaginationState = (page, maxPages) => {
			layout.dataset.currentPage = String(page);
			layout.dataset.maxPages = String(maxPages);

			if (loadMore) {
				loadMore.hidden = page >= maxPages;
			}
		};

		const requestProducts = (page, append) => {
			const form = getActiveForm();

			if (loading || !form) {
				return;
			}

			setLoading(true);

			const formData = new FormData(form);
			appendPriceFiltersToFormData(formData, form);
			appendSortToFormData(formData);
			formData.append('action', 'filter_products');
			formData.append('nonce', themeAjax.productNonce);
			formData.append('term_id', String(termId));
			formData.append('page', String(page));

			if (append) {
				formData.append('append', '1');
			}

			fetch(themeAjax.ajaxUrl, {
				method: 'POST',
				body: formData,
				credentials: 'same-origin',
			})
				.then((response) => response.json())
				.then((response) => {
					if (!response.success) {
						throw new Error('Catalog ajax failed');
					}

					const html = response.data.html || '<p class="catalog-products__empty">Товары не найдены</p>';

					if (append) {
						items.insertAdjacentHTML('beforeend', html);
					} else {
						items.innerHTML = html;
					}

					if (window.CarrotsBoxCatalogImages) {
						window.CarrotsBoxCatalogImages.enqueue(items);
					}

					updatePaginationState(response.data.page, response.data.max_pages);

					const params = buildSearchParams();
					const query = params.toString();
					const nextUrl = query ? `${window.location.pathname}?${query}` : window.location.pathname;
					window.history.replaceState({}, '', nextUrl);
					if (typeof response.data.found === 'number') {
						updateMobileProductCountDisplay(response.data.found);
					}

					updateActiveFilterChips();
					[desktopForm, mobileForm].filter(Boolean).forEach(updateFilterLabelStates);
					updateResetButton();
				})
				.catch(() => {
					if (!append) {
						items.innerHTML = '<p class="catalog-products__empty">Не удалось загрузить товары</p>';
					}
				})
				.finally(() => {
					setLoading(false);
				});
		};

		const scheduleFilter = () => {
			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(() => requestProducts(1, false), 300);
		};

		const initFormHandlers = (targetForm) => {
			if (!targetForm) {
				return;
			}

			const priceBlock = getPriceBlock(targetForm);

			if (priceBlock) {
				const minInput = targetForm.querySelector('.catalog-filters__range--min');
				const maxInput = targetForm.querySelector('.catalog-filters__range--max');
				const minThumb = priceBlock.querySelector('.catalog-filters__range-thumb--min');
				const maxThumb = priceBlock.querySelector('.catalog-filters__range-thumb--max');
				const minTextInput = priceBlock.querySelector('.catalog-filters__price-input--min');
				const maxTextInput = priceBlock.querySelector('.catalog-filters__price-input--max');

				const setActiveRange = (input) => {
					[
						{ input: minInput, thumb: minThumb },
						{ input: maxInput, thumb: maxThumb },
					].forEach(({ input: rangeInput, thumb }) => {
						const isActive = rangeInput === input;

						if (rangeInput) {
							rangeInput.classList.toggle('is-active', isActive);
						}

						if (thumb) {
							thumb.classList.toggle('is-active', isActive);
						}
					});
				};

				[minInput, maxInput].forEach((input) => {
					if (!input) {
						return;
					}

					input.addEventListener('pointerdown', () => setActiveRange(input));
					input.addEventListener('input', () => {
						syncPriceRanges(input, targetForm);
						scheduleFilterUpdate(targetForm);
					});
				});

				[minTextInput, maxTextInput].forEach((input) => {
					if (!input) {
						return;
					}

					const applyTextInput = () => {
						syncPriceFromText(input, targetForm);
						scheduleFilterUpdate(targetForm);
					};

					input.addEventListener('change', applyTextInput);
					input.addEventListener('blur', applyTextInput);
					input.addEventListener('keydown', (event) => {
						if (event.key === 'Enter') {
							event.preventDefault();
							input.blur();
						}
					});
				});

				document.addEventListener('pointerup', () => setActiveRange(null));
				updatePriceLabels(targetForm);
			}

			targetForm.querySelectorAll('.catalog-filters__input').forEach((input) => {
				input.addEventListener('change', () => {
					updateFilterLabelStates(targetForm);
					syncForms(targetForm);
					scheduleFilterUpdate(targetForm);
				});
			});
		};

		initFormHandlers(desktopForm);
		initFormHandlers(mobileForm);

		if (resetBtn) {
			resetBtn.addEventListener('click', () => {
				resetAllFilters();
				closeMobileFilters();
			});
		}

		const mobileFiltersReset = document.querySelector('.catalog-mobile-filters__bottom .btn-grey');

		if (mobileFiltersReset) {
			mobileFiltersReset.addEventListener('click', () => {
				resetAllFilters();
				closeMobileFilters();
			});
		}

		if (mobileFiltersApply) {
			mobileFiltersApply.addEventListener('click', () => {
				if (mobileForm) {
					syncForms(mobileForm);
				}

				requestProducts(1, false);
				closeMobileFilters();
			});
		}

		if (pickedClear) {
			pickedClear.addEventListener('click', resetAllFilters);
		}

		if (pickedScroll) {
			pickedScroll.addEventListener('scroll', updatePickedCarouselArrows, { passive: true });
		}

		if (pickedPrev) {
			pickedPrev.addEventListener('click', () => scrollPickedCarousel(-1));
		}

		if (pickedNext) {
			pickedNext.addEventListener('click', () => scrollPickedCarousel(1));
		}

		if (loadMore) {
			loadMore.addEventListener('click', () => {
				const nextPage = parseInt(layout.dataset.currentPage || '1', 10) + 1;
				requestProducts(nextPage, true);
			});
		}

		const sortSelectRoot = sortSelect?.closest('[data-custom-select]');
		if (sortSelectRoot) {
			sortSelectRoot.addEventListener('custom-select:change', () => {
				requestProducts(1, false);
			});
		}

		bindPickedChipHandlers();
		schedulePickedCarouselUpdate();
		updateResetButton();
		window.addEventListener('resize', schedulePickedCarouselUpdate, { passive: true });
	});
})();
